import { render, staticRenderFns } from "./AnimatedSection.vue?vue&type=template&id=1887cba4&scoped=true"
import script from "./AnimatedSection.vue?vue&type=script&lang=js"
export * from "./AnimatedSection.vue?vue&type=script&lang=js"
import style0 from "./AnimatedSection.vue?vue&type=style&index=0&id=1887cba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887cba4",
  null
  
)

export default component.exports